<template>
  <div>
    <b-container class="container card">
      <div class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-search"></i>
            <span>بحث</span>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="form row card-search">
              <div class="form-group col-md-3">
                <label for="">كود الموظف</label>
                <input type="text" class="form-control" v-model="s_id" />
              </div>

              <div class="form-group col-md-3">
                <label for="">الاسم الاول</label>
                <input type="text" class="form-control" v-model="s_Fname" />
              </div>

              <div class="form-group col-md-3">
                <label for="">اللقب</label>
                <input type="text" class="form-control" v-model="s_Ffname" />
              </div>

             <div class="form-group col-md-3">
                <label for="">الجنسية</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_nats"
                >
                  <option
                    v-for="nat in nats"
                    :value="nat.id"
                    :key="nat.id"
                  >
                    {{ nat.nName }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label for="">الجوال</label>
                <input type="number" class="form-control" v-model="s_Mob" />
              </div>
              
             <div class="form-group col-md-3">
                <label for="">الوظيفة</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_job"
                >
                  <option
                    v-for="job in jobs"
                    :value="job.id"
                    :key="job.id"
                  >
                    {{ job.job }}
                  </option>
                </select>
              </div>
             
              <div class="form-group col-md-3">
                <label for="">كود الباص</label>
                <input type="number" class="form-control" v-model="s_busCode" />
              </div>

               <div class="form-group col-md-3">
                <label for="">رقم العقد</label>
                <input type="number" class="form-control" v-model="s_contract" />
              </div>

              <div class="form-group col-md-3">
                <label for="">خط السير من</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_workarea"
                >
                  <option
                    v-for="workarea in workarea"
                    :value="workarea.id"
                    :key="workarea.id"
                  >
                    {{ workarea.areaName }}
                  </option>
                </select>
              </div>
                        <div class="form-group col-md-3">
                <label for="">خط السير الى</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_traffic"
                >
                  <option
                    v-for="traffic in traffic"
                    :value="traffic.id"
                    :key="traffic.id"
                  >
                    {{ traffic.trafficTo }}
                  </option>
                </select>
              </div>
             
              <div class="form-group col-md-3">
                <button @click="clear" class="btn btn-danger">
                  الغاء البحث
                </button>
                 <button v-if="c_print" @click="print" class="btn btn-success">
                  طباعة
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="nav nav-tabs view-mode">
        <li class="nav-item ">
          <a class="nav-link active" data-toggle="tab" href="#home">
            <i class="fa fa-table"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#menu1">
            <i class="fa fa-bars"></i>
          </a>
        </li>
      </ul>
       <div class="m-auto">
            <b-button v-if="c_add" to="createEmp" variant="outline-primary">إضافة</b-button>
            <div class="std-count">
              <span class="text-danger">
                عدد الموظفين
              </span>
              <span> | </span>
              <span class="text-success"> {{items.length}} </span>
            </div>
          </div>
      <div class="tab-content">
        <div class="tab-pane container active overflow" id="home">
         
          <!-- Main table element -->

          <b-table
            :busy="isBusy"
            :bordered="true"
            :no-border-collapse="true"
            show-empty
            striped
            hover
            small
            stacked="sm"
            :fields="fields"
            :current-page="currentPage"
            :per-page="10"
            :items="filtered"
            head-variant="dark"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            sort-icon-left
          >
            <template v-slot:head(id) style="background-color:red;">
              <span class="text-info">كود الموظف</span>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> جارى التحميل ... </strong>
              </div>
            </template>
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'id' ? '20px' : '20px' }"
              />
            </template>
            <template slot="top-row" slot-scope="{ fields }">
              <td v-for="field in fields" :key="field.key">
                <input
                  v-model="filters[field.key]"
                  :placeholder="field.label"
                />
              </td>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
              v-if="c_update"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                :to="'/updateEmp/' + row.item.id"
                variant="outline-warning"
              >
                تعديل
              </b-button>
              <b-button
              v-if="c_delete"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-danger"
              >
                حذف
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col sm="7" md="6" class="m-auto">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class=""
              ></b-pagination>
            </b-col>
          </b-row>
          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center">
              <b-row>
                <div class="card-body">
                  <span>
                    هل انت متأكد من حذف الموظف ؟
                  </span>
                  <span class="text-dark">{{
                    " " + delitem.Fname + " " + delitem.Ffname
                  }}</span>
                </div>
              </b-row>
              <div class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-danger"
                      :disabled="busy"
                      @click="remove(delitem)"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ btnDelMessage }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </b-modal>
        </div>
        <div class="tab-pane container fade" id="menu1">
          <div class="container">
            <div class="row">
              <div class="col-md-3" v-for="item in items" :key="item.id">
                <div class="itm card">
                  <div class="card-header">
                    <span>الاسم</span>
                    <span> | </span>
                    <span class="text-warning"> {{ item.Fname }} </span>
                    <span class="text-warning"> {{ item.Ffname }} </span>
                  </div>
                  <table>
                    <tr>
                      <td>الكود</td>
                      <td>|</td>
                      <td>{{ item.id }}</td>
                    </tr>
                    <tr>
                      <td>الجوال</td>
                      <td>|</td>
                      <td>{{ item.Mob }}</td>
                    </tr>
                    <tr>
                      <td>الجنسية</td>
                      <td>|</td>
                      <td>{{ item.Nname }}</td>
                    </tr>
                    <tr>
                      <td>الوظيفة</td>
                      <td>|</td>
                      <td>{{ item.job }}</td>
                    </tr>
                    <tr>
                      <td>كود الباص</td>
                      <td>|</td>
                      <td>{{ item.bus_id }}</td>
                    </tr>
                    <tr>
                      <td>رقم العقد</td>
                      <td>|</td>
                      <td>{{ item.driverContractNum }}</td>
                    </tr>
                    <tr>
                      <td>خط السير من</td>
                      <td>|</td>
                      <td>{{ item.areaName }}</td>
                    </tr>
                      <tr>
                      <td>خط السير الى</td>
                      <td>|</td>
                      <td>{{ item.trafficTo }}</td>
                    </tr>
                  </table>

                  <div class="card-footer m-auto">
                    <b-button
                    v-if="c_update"
                      size="sm"
                      class="mr-1"
                      :to="'/updateEmp/' + item.id"
                      variant="outline-warning"
                    >
                      تعديل
                    </b-button>
                    <b-button
                    v-if="c_delete"
                      size="sm"
                      @click="infoDel(item.id)"
                      class="mr-1"
                      variant="outline-danger"
                    >
                      حذف
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
//import axios from 'axios'
import { mapState, mapGetters, mapActions } from "vuex";
import indexLayout from "../../layouts/indexLayout.vue";
export default {
  name: "emps",
  data() {
    return {
      s_id: "",
      s_Fname: "",
      s_Ffname: "",
      s_Mob: "",
      s_busCode: "",
      s_nats: "",
      s_job: "",
      s_contract: "",
      s_workarea: "",
      s_traffic: "",
      isBusy: true,
      students: [],
      busy: false,
      btnDelMessage: "حذف",
      items: [],
      delitem: "",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
            /*check role */
c_add:false,
c_update:false,
c_delete:false,
c_print:false,

/*check end */
      fields: [
        {
          key: "id",
          label: "كود الموظف",
          sortable: true,
          class: "f-id",
          sortDirection: "desc",
          tdClass: "fid",
        },
        {
          key: "Fname",
          label: "الاسم الاول",
          sortable: true,
          class: "text-center",
        },
        {
          key: "Ffname",
          label: "اسم العائلة",
          sortable: true,
          class: "text-center",
        },
        {
          key: "bus_id",
          label: "كود الباص",
          sortable: true,
          class: "text-center",
        },
        {
          key: "Nname",
          label: "الجنسية",
          sortable: true,
          class: "text-center",
        },

        { key: "actions", label: "" },
      ],
      filters: {
        id: "",
        Fname: "",
        Ffname: "",
        bus_id: "",
        Nname: "",
 
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
    created(){
      this.$emit('update:layout',indexLayout)
      this.Role_check();
    },

  computed: {
    ...mapGetters({
      load: "empMod/GET_ALLDATA",
      check : "GET_ROLES"
    }),
    ...mapState(["nats", "jobs", "workarea", "traffic"]),

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    filtered() {
      const filtered = this.items.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key]).includes(this.filters[key])
        );
      });
      return filtered.length > 0
        ? filtered
        : [
            {
            id: "",
        Fname: "",
        Ffname: "",
        bus_id: "",
        Nname: "",
            },
          ];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions({
      loadData: "empMod/fetchData",
      deleData: "empMod/deleteData",
    }),
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.delitem = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    infoDel: function(id) {
      var item = this.items.find((todo) => todo.id == id);
      this.infoModal.title = item.id;
      this.delitem = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id);
    },
    async remove(stdRow) {
      this.busy = true;
      await this.deleData(stdRow);
      this.btnDelMessage = "تم الحذف";
      this.busy = false;
      this.items = this.load;
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    async getData() {
      await this.$store.dispatch("empMod/fetchData");
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;
      // if (this.load.length > 0) {
      //   this.items = this.load;
      //   this.totalRows = this.items.length;
      //   this.isBusy = false;
      // } else {

      // }
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Cfilter() {
      this.items = this.load;
      this.items = this.items.filter((t) =>
        t.id.toString().includes(this.s_id)
      );
      this.items = this.items.filter((t) =>
        t.Fname.toString().includes(this.s_Fname)
      );
      this.items = this.items.filter((t) =>
        t.Ffname.toString().includes(this.s_Ffname)
      );
      this.items = this.items.filter((t) =>
        t.Mob.toString().includes(this.s_Mob)
      );
      this.items = this.items.filter((t) =>
        t.nat_id.toString().includes(this.s_nats)
      );
      this.items = this.items.filter((t) =>
        t.job_id.toString().includes(this.s_job)
      );
      this.items = this.items.filter((t) =>
        t.bus_id.toString().includes(this.s_busCode)
      );
      this.items = this.items.filter((t) =>
        t.driverContractNum.toString().includes(this.s_contract)
      );
      this.items = this.items.filter((t) =>
        t.trafficFrom.toString().includes(this.s_workarea)
      );
      this.items = this.items.filter((t) =>
        t.trafficTo.toString().includes(this.s_traffic)
      );
 
    },
    clear() {
      this.s_id = "";
      this.s_Fname = "";
      this.s_Ffname = "";
      this.s_Mob = "";
      this.s_nats="";
      this.s_Mob="";
      this.s_job="";
      this.s_busCode="";
      this.s_contract="";
      this.s_workarea="";
      this.s_traffic="";
    },
    print(){
      this.$router.push({ name: 'empR' ,params: {load : this.items} })
    },
       Role_check(){
this.c_add =this.check.driver_add ==1 ? true : false;
this.c_update =this.check.driver_update ==1 ? true : false;
this.c_delete =this.check.driver_delete ==1 ? true : false;
this.c_print =this.check.driver_print ==1 ? true : false;

}
  },
  watch: {
    s_id: function() {
      this.Cfilter();
    },
    s_Fname: function() {
      this.Cfilter();
    },
    s_Ffname: function() {
      this.Cfilter();
    },
    s_nats: function() {
      this.Cfilter();
    },
    s_Mob: function() {
      this.Cfilter();
    },
    s_job: function() {
      this.Cfilter();
    },
    s_contract: function() {
      this.Cfilter();
    },
    s_workarea: function() {
      this.Cfilter();
    },
    s_traffic: function() {
      this.Cfilter();
    },
    s_busCode: function() {
      this.Cfilter();
    },
  },
};
</script>
<style lang="scss" scoped>
.b-table-top-row > td:last-child {
  visibility: hidden;
}
.nav-link.active {
  background-color: #ddab2b !important;
}
.fid {
  background-color: #ddab2b;
}
.itm {
  margin: 10px 0px;
  box-shadow: 0px 0px 6px 1px black;
  -moz-box-shadow: 0px 0px 6px 1px black;
  -o-box-shadow: 0px 0px 6px 1px black;
  -webkit-box-shadow: 0px 0px 6px 1px black;
}
</style>
